/* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */
import React, {useEffect, useState} from 'react'
import {css} from '@emotion/core'
import {getTheme, getThemeStyles, themes} from '../util/theme'
import {getLanguageCode} from '../util/locale'
import {getLocalizedFeedbackText} from '../util/captchaService'

import Layout from '../components/Layout'

const FeedbackPage = ({languageCode}) => {
    // just use default for captcha page, no need to get fancy ;)
    const [theme, setTheme] = useState('light')
    const [themeStyles, setThemeStyles] = useState({})

    const lang = languageCode || getLanguageCode()

    const {feedbackTitle, newBlockFooter} = getLocalizedFeedbackText(lang)

    useEffect(() => {
        const theme = getTheme()
        const themeStyles = getThemeStyles()
        setTheme(theme)
        setThemeStyles(themeStyles)
    }, [])

    return (
        <Layout
            title="Startpage Feedback"
            bannerTitle={feedbackTitle}
            description={`Startpage's feedback page`}
            lang={lang}
            canonicalPath="/"
            themeStyles={themeStyles}
            noFooter
            theme={theme}
            hidePrivacyDropdown
        >
            <section
                css={css`
                    background: ${themeStyles.lighterBackgroundColor};
                    p,
                    b,
                    li,
                    label,
                    span {
                        color: ${themeStyles.primaryTextColor};
                    }
                    padding: 7rem 1rem 8rem;
                `}
            >
                <div>
                    <div
                        css={css`
                            max-width: 800px;
                            margin: auto;
                            p {
                                margin-bottom: 2rem;
                            }
                            a {
                                color: ${themes.light.brandBlue};
                            }
                        `}
                    >
                        <section className="hero">
                            <p>{newBlockFooter}</p>
                        </section>
                    </div>
                </div>
            </section>
        </Layout>
    )
}

export default FeedbackPage
